/**
 * Voucher Component
 */
import {
  disableVoucherView,
  resetCardState,
} from "containers/Card/store/Actions";
import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CajitaStore } from "root/store/CajitaStore";

interface IVoucherProps {
  showVoucher?: boolean;
  amount: string | number | object;
  deferredType: string;
  months: string;
  monthsOfGrace: string;
  amountPerMonth: string;
  currency: string;
  isDeferred: boolean;
}

/**
 * Voucher Class Component
 */
class VoucherView extends React.Component<CardState> {
  constructor(props: CardState) {
    super(props);
  }

  public render(): React.ReactNode {
    const class_text_right: string = "col-xs-12 voucherTitle";
    const class_value_label: string = "voucherValue";

    return (
      <div>
        <Modal isOpen={this.props.showVoucher}>
          <ModalHeader>
            <Translate id={"transactionResume"} />
          </ModalHeader>
          <ModalBody>
            <Container className={"pl-5"}>
              <Row>
                <Col sm={{ size: 12 }}>
                  <Row>
                    <Col sm={{ size: 6 }} className={`${class_text_right}`}>
                      <strong>
                        <Translate id={"valueToPay"} />
                      </strong>
                    </Col>
                    <Col sm={{ size: 6 }} className={class_value_label}>
                      <div>
                        {this.props.amount} {this.props.currency}
                      </div>
                    </Col>
                  </Row>
                </Col>
                {this.props.isDeferred ? (
                  <Row id={"deferred"}>
                    <Col sm={{ size: 12 }}>
                      <Row>
                        <Col sm={{ size: 6 }} className={class_text_right}>
                          <strong>
                            <Translate id={"numberOffees"} />
                          </strong>
                        </Col>
                        <Col sm={{ size: 6 }} className={class_value_label}>
                          <div>{this.props.months}</div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={{ size: 12 }}>
                      <Row>
                        <Col sm={{ size: 6 }} className={class_text_right}>
                          <strong>
                            <Translate id={"amountPerFee"} />
                          </strong>
                        </Col>
                        <Col sm={{ size: 6 }} className={class_value_label}>
                          <div>
                            {this.props.amountPerMonth} {this.props.currency}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : null}
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Container>
              <Row>
                <Col xs="12" className={"text-center mb-2"}>
                  <Button
                    onClick={(): void => this.props.disableVoucherView()}
                    className="confirm-button confirmCodeButton"
                  >
                    <Translate id={"continue"} />
                  </Button>
                </Col>
                <Col xs="12" className={"text-center"}>
                  <a
                    id={"resetTag"}
                    className={"linkColor"}
                    onClick={(): void => this.props.resetCardState()}
                  >
                    <Translate id={"back"} />
                  </a>
                </Col>
              </Row>
            </Container>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps: (state: CajitaStore) => IVoucherProps = (
  state: CajitaStore
): IVoucherProps => ({
  showVoucher: state.card.showVoucher,
  amount: state.config.amount,
  deferredType: state.card.deferredOptionsComponent.deferredTypeSelect.value,
  months: state.card.deferredOptionsComponent.monthsSelect.value,
  monthsOfGrace: state.card.deferredOptionsComponent.monthsOfGraceSelect.value,
  amountPerMonth: state.card.amountPerMonth,
  currency: state.config.currency,
  isDeferred: state.card.isDeferred,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  disableVoucherView: (): void => dispatch(disableVoucherView()),
  resetCardState: (): void => dispatch(resetCardState()),
});

const VoucherViewComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(VoucherView);

export { VoucherViewComponent };



// WEBPACK FOOTER //
// ./src/components/VoucherView/VoucherViewComponent.tsx